import { TENANT, Tenant } from './tenant';

const defaultFavicon = '/favicons/favicon.ico';

const tenantToFaviconMap = new Map<Tenant, string>([
  [Tenant.avelios, defaultFavicon],
  [Tenant.sana, '/favicons/favicon-sana.ico'],
]);

export const TENANT_FAVICON: string = ((tenant: Tenant) => {
  const favicon = tenantToFaviconMap.get(tenant);

  if (favicon) {
    return favicon;
  }

  console.warn(`No favicon defined for tenant ${tenant}. Falling back to default.`);
  return defaultFavicon;
})(TENANT);
